export default "__VITE_ASSET__d4595768__"